import {useMutation} from 'react-query';
import PostAddChat from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IUsePostAddChatProps {
  onSuccess?: (data: IPostAddChatData) => void;
}
const usePostAddChat = ({onSuccess}: IUsePostAddChatProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPayloadPostAddChat) => {
      return PostAddChat(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoadingAddChat: isLoading, isSuccess, mutateAddChat: mutate};
};

export default usePostAddChat;
